<template>
  <section id="services" class="overflow-hidden">
    <v-row class="accent" no-gutters>
      <v-col class="pa-5" cols="12">
        <v-row class="fill-height" align="center" justify="center">
          <v-col cols="12" md="8" lg="8">
            <heading tag="h2" class="display-1 mb-3">
              Why should I use Virtual House Pro?
            </heading>
            <v-row>
              <v-expansion-panels>
                <v-expansion-panel v-for="(service, i) in services" :key="i">
                  <v-expansion-panel-header class="align-center">
                    <v-avatar
                      class="elevation-0 mr-5 primary secondary--text"
                      rounded
                      size="32"
                      style="flex: 0;"
                    >
                      <v-icon
                        size="24"
                        v-text="service.icon"
                        class="secondary--text"
                      />
                    </v-avatar>
                    <heading v-text="service.name" tag="h3"></heading>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <base-text
                      v-text="service.blurb"
                      style="margin: 0"
                    ></base-text>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </v-col>
          <v-col cols="12" md="8" lg="8">
            <v-btn
              class="primary secondary--text rounded-md"
              to="schedule"
              x-large
            >
              Get Started
              <v-icon right>fa-angle-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import BaseText from "@/components/base/Text";
import Heading from "@/components/base/Heading";

export default {
  name: "Services",
  components: {
    BaseText,
    Heading
  },
  data: () => ({
    services: [
      {
        name: "“Pro-stamp” Home buy!",
        icon: "fa-home",
        blurb:
          "Using your phone or other handheld device we can walk though a potential home interest and give you real time estimates towards renovations or design ideas which will give you confidence moving forward!   *This is perfect for realtors and potential buyers as a tool we think can greatly help in the home buying process (We recommend a back to back time slot for this service)"
      },
      {
        name: "DIY Projects",
        icon: "fa-ruler-combined",
        blurb:
          'Get real time instruction, material lists, and the correct products that will be needed for your project along with some "tricks of the trade" that will help things go smoother :)'
      },
      {
        name: "Real Time Estimates",
        icon: "fa-clock",
        blurb:
          "Get non-bias, real time estimates on future projects or remodels so you can plan and save without being surprised by final cost."
      },
      {
        name: "Pre-Estimates",
        icon: "fa-comment-dollar",
        blurb:
          "Get a pre-estimate and gain an understanding of your project before having a contractor or subcontractor come to your home. Knowledge is power and it can save you a lot of time and money!"
      },

      {
        name: "Contractor or self-contractor guidance",
        icon: "fa-hard-hat",
        blurb:
          "Whether you are hiring a contractor in your area or trying to take the job on yourself, let us be a sounding board along the way and give you an understanding of the process and expectations that go along with your project.  There are a lot of ways to approach a project and having a non-bias, trustworthy soundboard to help guide you is is worth every penny!"
      },
      {
        name: "Project Brainstorm and Design",
        icon: "fa-paint-roller",
        blurb:
          "Where do I start?...let us talk over your next remodel with you and give you any direction or feedback that might help get you on your way! This is perfect for the “Pinterest” type. Users and couples that are just trying to begin the process and need help getting going with ideas and possibilities in their space."
      },
      {
        name: "Home 101",
        icon: "fa-tools",
        blurb:
          "Maybe you have never owned a home and just want to have an understanding of how your home works?! Let us give some maintenance and upkeep advice that will keep your home running smoothly for years to come!"
      },
      {
        name: "and more...",
        icon: "fa-comment-dots",
        blurb:
          "Don't see something here that fits your specific needs?  Email us and we'll see if we can help."
      }
    ]
  })
};
</script>
